<template>
  <div class="progress-bar">
    <div
      v-bind:style="{ width: value + '%' }"
      class="progress-bar--filled"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    value: Number
  },
  data() {
    return {
      data: {}
    };
  },
  mounted() {},
  methods: {
    back() {
      //service.send("continue");
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
@barHeight: 2px;
.progress-bar {
  width: 100%;
  height: @barHeight;
  background: #eaeaea;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  .progress-bar--filled {
    background: #CC4B00;
    height: @barHeight;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
